import classNames from 'classnames';
import PropTypes from 'prop-types';

import Chip from '@mui/material/Chip';

import { useStyles } from './index.styles';

const CardLabel = ({
  className,
  icon = null,
  text
}) => {
  const classes = useStyles();

  return (
    <Chip
      className={classNames(classes.card__label, className)}
      icon={icon}
      label={text}
      data-testid="card-label"
    />
  );
};

CardLabel.propTypes = {
  /** Override or extend the styles applied to the component. */
  className: PropTypes.string,
  /** The icon to display to left of text. */
  icon: PropTypes.element,
  /** Text to be used for the label. */
  text: PropTypes.node.isRequired
};

export default CardLabel;
